import React, { useState } from "react";
import { services } from "../mock/mock";
import { ArrowUpRight, Sparkles, BrainCircuit, MessageSquareQuote } from "lucide-react";

const iconMap = {
  Sparkles,
  BrainCircuit,
  MessageSquareQuote,
};

const Services = () => {
  const [active, setActive] = useState(services[0].id);

  return (
    <section id="services" aria-labelledby="services-heading" className="relative bg-[#0F0F0F] text-[#FAFAF7] py-24 md:py-32">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 mb-14">
          <div className="lg:col-span-3">
            <p className="font-mono text-[11px] uppercase tracking-[0.22em] text-[#9a9a93] mb-3">
              — (02) Services
            </p>
            <h2 id="services-heading" className="font-display text-3xl md:text-4xl font-medium leading-tight">
              Three programs.<br />One visibility moat.
            </h2>
          </div>
          <div className="lg:col-span-9 lg:pt-8">
            <p className="font-display text-2xl md:text-[28px] leading-[1.3] font-light text-[#d8d8d2] max-w-3xl">
              Engagements are tailored, but they all draw from the same toolkit
              — a strategy layer that links classical SEO with how large language
              models actually source, rank and quote information.
            </p>
          </div>
        </div>

        {/* Service rows */}
        <div className="border-t border-[#26262a]">
          {services.map((s) => {
            const Icon = iconMap[s.icon] || Sparkles;
            const isActive = active === s.id;
            return (
              <div
                key={s.id}
                onMouseEnter={() => setActive(s.id)}
                className={`group border-b border-[#26262a] transition-colors duration-500 ${
                  isActive ? "bg-[#141417]" : "bg-transparent"
                }`}
              >
                <div className="grid grid-cols-12 gap-4 md:gap-8 py-8 md:py-10 px-2 md:px-4 cursor-default">
                  <div className="col-span-2 md:col-span-1 font-mono text-sm text-[#9a9a93] pt-2">
                    {s.code}
                  </div>
                  <div className="col-span-10 md:col-span-4">
                    <div className="flex items-center gap-3 mb-2">
                      <Icon className="h-5 w-5 text-[#C8FF3D]" />
                      <h3 className="font-display text-2xl md:text-3xl font-medium">
                        {s.title}
                      </h3>
                    </div>
                    <p className="text-[#9a9a93] text-sm md:text-base">
                      {s.short}
                    </p>
                  </div>
                  <div className="col-span-12 md:col-span-5 text-[15px] text-[#d8d8d2] leading-relaxed">
                    {s.description}
                  </div>
                  <div className="col-span-12 md:col-span-2">
                    <ul className="space-y-2">
                      {s.deliverables.slice(0, 4).map((d) => (
                        <li key={d} className="font-mono text-[11px] uppercase tracking-wider text-[#bcbcb3]">
                          — {d}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
                <div
                  className={`overflow-hidden transition-all duration-500 ${
                    isActive ? "max-h-12 opacity-100" : "max-h-0 opacity-0"
                  }`}
                >
                  <div className="flex items-center gap-2 px-2 md:px-4 pb-6">
                    <span className="h-px flex-1 bg-[#C8FF3D]/40"></span>
                    <a
                      href="#contact"
                      onClick={(e) => {
                        e.preventDefault();
                        document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
                      }}
                      className="group/link inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-[0.2em] text-[#C8FF3D] hover:text-[#FAFAF7] transition-colors"
                    >
                      Discuss this engagement
                      <ArrowUpRight className="h-4 w-4 transition-transform group-hover/link:translate-x-0.5 group-hover/link:-translate-y-0.5" />
                    </a>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
